import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { resources } from './i18n/translations';

function getActualLanguage() {
	try {
		const language = localStorage.getItem('language');
		return language;
	} catch (err) {
		console.log(err);
	}
}

const actualLanguage = getActualLanguage();

i18n
	// pass the i18n instance to react-i18next.
	.use(initReactI18next)
	// init i18next
	.init({
		debug: false,
		lng: actualLanguage || 'ptBr',
		interpolation: {
			escapeValue: false // not needed for react as it escapes by default
		},
		resources
	});

export default i18n;
